import { API_URL_PATHS } from 'src/common/consts/ApiUrlPaths';

const { VALUES_OVERRIDE_PATH } = API_URL_PATHS;

export const CORE_LABELS_OVERRIDE_PATH = `${VALUES_OVERRIDE_PATH}/PLATFORM/CORE_LABELS`;
export const ADDITIONAL_LABELS_OVERRIDE_PATH = `${VALUES_OVERRIDE_PATH}/PLATFORM/ADDITIONAL_LABELS`;
